<template lang="pug">
    #imagem
        // img(:src="require('@images/mini-banner.jpg')")
</template>

<script>
export default {
    name: "component-imagem",
}
</script>

<style lang="stylus" scoped src="./Imagem.styl"></style>